import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { ContentService } from '../content.service';
import { ContentManager } from '../content-manager';

@Component({
    selector: 'chatbot-message-multi-options',
    templateUrl: './message-multi-options.component.html',
    styleUrls: ['./message-multi-options.component.less']
})
export class MessageMultiOptionsComponent implements OnInit, AfterViewInit {

    @Input() params: any;
    @Input() content: ContentManager;

    active = false;
    enabled = true;
    selected = false;
    checked = false;
    value = null;

    constructor(private el: ElementRef) { }

    ngOnInit() {
        this.value = this.params.selected || {};
        this.selected = !!this.params.selected;
        this.checkChecked();
    }

    get multi() {
        return !!this.params.multi;
    }

    get horizontal() {
        return !!this.params.horizontal;
    }

    get vertical() {
        return !!this.params.vertical;
    }

    get className() {
        return this.params.className || "";
    }

    get disableOptions() {
        return this.params.disableOptions || [];
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.active = true;
            this.content.reportUpdated(null);
        }, 0);
    }

    toggle(option) {
        if (!option.disabled) {
            this.value[option.field] = !this.value[option.field];
        }

        if (this.disableOptions.length) {
            var listKey = [];
            var objValue = Object.keys(this.value);
            for (var objKey of objValue) {
                if (this.value[objKey]) {
                    listKey.push(objKey);
                }
            }

            let match = false;
            this.disableOptions.forEach(item => {
                if (listKey.indexOf(item.field) > -1) {
                    match = true;
                }
            })

            this.params.options.forEach(item => {
                if (this.disableOptions.findIndex(a => a.field === item.field) > -1) {
                    item.disabled = false;
                } else {
                    item.disabled = match;
                    if (match) {
                        delete this.value[item.field];
                    }
                }
            })
        }

        this.checkChecked();
    }

    onSubmit() {
        this.enabled = false;
        this.selected = true;
        this.content.reportValue(this.value);
    }

    checkChecked() {
        this.checked = Object.values(this.value).indexOf(true) >= 0;
    }
}
